export default __webpack_public_path__ + "static/media/logoName.779d0755.png";